export const stickyFilters = () => {
    const myFilters = document.querySelectorAll('.sub-sect-divider');
    const fixedTop = document.querySelector('.sticky-filters-top');

    if (myFilters && fixedTop) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    fixedTop.classList.remove('fixed-top');
                } else {
                    fixedTop.classList.add('fixed-top');
                }
            });
        });

        Array.prototype.forEach.call(myFilters, (el) => {
            observer.observe(el);
        });
    }
};

export const polyclinicsObserver = () => {
    const alphabetFilter = document.querySelector('.alphabet-filter-sticky');
    const poliObserver = document.querySelectorAll('.sticky-buttons-observer');
    const target = document.querySelector('.inner-alphabet-sticky-top');

    if (alphabetFilter) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    target.classList.remove('sticky-hidden-top');
                } else {
                    target.classList.add('sticky-hidden-top');
                }
            });
        });

        Array.prototype.forEach.call(poliObserver, (el) => {
            observer.observe(el);
        });
    }
};

export const centrumHeaderObserver = () => {
    const centrumObserver = document.querySelectorAll(
        '.centrum-header-intersection-observer'
    );
    const centrumHeaderUpper = document.querySelector('.centrum-header-upper');
    const centrumHeaderLower = document.querySelector('.centrum-header-lower');

    if (centrumObserver[0]) {
        const observerClassList = document.querySelector(
            '.centrum-header-intersection-observer'
        ).classList;
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    centrumHeaderUpper.classList.remove('upper-scrolled');

                    // eslint-disable-next-line default-case
                    switch (true) {
                        case observerClassList.contains('pale-observer'):
                            centrumHeaderLower.classList.remove(
                                'lower-scrolled--pale'
                            );
                            break;
                        case observerClassList.contains('pistache-observer'):
                            centrumHeaderLower.classList.remove(
                                'lower-scrolled--pistache'
                            );
                            break;
                        case observerClassList.contains('sky-observer'):
                            centrumHeaderLower.classList.remove(
                                'lower-scrolled--sky'
                            );
                            break;
                        case observerClassList.contains('light-peach-observer'):
                            centrumHeaderLower.classList.remove(
                                'lower-scrolled--light-peach'
                            );
                            break;
                        case observerClassList.contains('lavender-observer'):
                            centrumHeaderLower.classList.remove(
                                'lower-scrolled--lavender'
                            );
                            break;
                    }
                } else {
                    centrumHeaderUpper.classList.add('upper-scrolled');

                    // eslint-disable-next-line default-case
                    switch (true) {
                        case observerClassList.contains('pale-observer'):
                            centrumHeaderLower.classList.add(
                                'lower-scrolled--pale'
                            );
                            break;
                        case observerClassList.contains('pistache-observer'):
                            centrumHeaderLower.classList.add(
                                'lower-scrolled--pistache'
                            );
                            break;
                        case observerClassList.contains('sky-observer'):
                            centrumHeaderLower.classList.add(
                                'lower-scrolled--sky'
                            );
                            break;
                        case observerClassList.contains('light-peach-observer'):
                            centrumHeaderLower.classList.add(
                                'lower-scrolled--light-peach'
                            );
                            break;
                        case observerClassList.contains('lavender-observer'):
                            centrumHeaderLower.classList.add(
                                'lower-scrolled--lavender'
                            );
                            break;
                    }
                }
            });
        });

        Array.prototype.forEach.call(centrumObserver, (el) => {
            observer.observe(el);
        });
    }
};
